import { render, staticRenderFns } from "./projectSurvey.vue?vue&type=template&id=9cbf4e50&scoped=true"
import script from "./projectSurvey.vue?vue&type=script&lang=js"
export * from "./projectSurvey.vue?vue&type=script&lang=js"
import style0 from "./home.scss?vue&type=style&index=0&id=9cbf4e50&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbf4e50",
  null
  
)

export default component.exports